<template>
	<el-dialog title="派单详情" :visible.sync="show" @closed="close" width="600px" :before-close="closeDialog">
		<div class="form-box padding-30">
			<el-form ref="form" :model="form" label-width="auto" :rules="rules">
				<el-form-item label="派单编号：" prop="order_no">
					<span class="text-bold">#{{form.order_no||'无编号'}}</span>
				</el-form-item>
				<el-form-item label="事故地点：" prop="address">
					<el-input :disabled="!form.is_update||form.is_taking" v-model.trim="form.address" placeholder="请输入事故地点"></el-input>
				</el-form-item>
				<el-form-item label="事故类型：" prop="accident_type">
					<el-select :disabled="!form.is_update||form.is_taking" v-model="form.accident_type" filterable placeholder="请选择事故类型" style="width: 100%;">
						<el-option v-for="item in SelectInfo.accident_type" :key="item.id" :label="item.name"
							:value="item.name"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="现场民警电话：" prop="phone">
					<el-input :disabled="!form.is_update||form.is_taking" v-model.trim="form.phone" maxlength="11" placeholder="请输入现场民警电话"></el-input>
				</el-form-item>
				<el-form-item label="施救人员：" prop="work_uid">
					<el-select :disabled="!form.is_update||form.is_taking" @change="getPhone" v-model="form.work_uid" filterable placeholder="请选择施救人员"
						style="width: 100%;">
						<el-option v-for="item in SelectInfo.rescuers" :key="item.id" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="施救人员电话：" prop="work_phone">
					<el-input :disabled="!form.is_update||form.is_taking" v-model.trim="form.work_phone" placeholder="请输入施救人员电话" maxlength="11"></el-input>
				</el-form-item>
				<el-form-item label="备注：" prop="remark">
					<el-input :disabled="!form.is_update||form.is_taking" type="textarea" :rows='4' v-model.trim="form.remark"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="closeDialog">返回</el-button>
					<el-button :disabled="!form.is_update||form.is_taking" style="width: 270px;" type="primary" @click="onSubmit">确认修改</el-button>
				</el-form-item>
			</el-form>
		</div>
	</el-dialog>
</template>

<script>
	import {
		mapState
	} from "vuex";
	export default {
		name: "editDialog",
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			info: {
				type: Object,
				default: () => {
					return {};
				}
			},
		},
		computed: {
			...mapState(["SelectInfo"]),
		},
		watch: {
			info: {
				handler: function(val) {
					this.form = JSON.parse(JSON.stringify(val));
				},
				deep: true,
			}
		},
		data() {
			var validatePhone = (rule, value, callback) => {
				var isMobile = /^1[3456789]\d{9}$/.test(value);
				if (!isMobile) callback(new Error('请填写正确的手机号码'));
				callback();
			};
			var validatePhone1 = (rule, value, callback) => {
				if (value) {
					var isMobile = /^1[3456789]\d{9}$/.test(value);
					if (!isMobile) callback(new Error('请填写正确的手机号码'));
				}
				callback();
			};
			return {
				form: {},
				rules: {
					address: [{
						required: true,
						message: '请输入事故地点',
						trigger: 'blur'
					}],
					accident_type: [{
						required: true,
						message: '请选择事故类型',
						trigger: 'blur'
					}],
					work_uid: [{
						required: true,
						message: '请选择施救人员',
						trigger: 'blur'
					}],
					phone: [{
						validator: validatePhone1,
						trigger: 'blur'
					}],
					work_phone: [{
						required: true,
						message: '请输入施救人员电话',
						trigger: 'blur'
					}, {
						validator: validatePhone,
						trigger: 'blur'
					}],
				}
			}
		},
		methods: {
			closeDialog() {
				this.$emit('update:show', false);
			},
			close() {
				console.log(2);

			},
			getPhone(id) {
				const user = this.SelectInfo.rescuers.find(v => v.id == id);
				if (user) this.form.work_phone = user.phone;
			},
			resetFields() {
				this.$refs['form'].resetFields();
			},
			onSubmit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.editTask();
					} else {
						return false;
					}
				});
			},
			/**
			 * 向后台发送请求，新增任务
			 */
			async editTask() {
				let res = await this.http.apiPost('v1/Park/EditOrder', this.form, true);
				if (res.flag) {
					this.$notify({
						title: '温馨提示',
						message: '修改成功',
						type: 'success',
						offset: 150,
						duration: 1500,
					});
					this.$emit('comfirm',this.form)
					this.closeDialog();
				} else {
					this.$message.error(res.msg);
				}
			},
		}
	}
</script>

<style>
</style>
